import { render, staticRenderFns } from "./CoursePointsDetailDialog.vue?vue&type=template&id=7b98ffbe&scoped=true&"
import script from "./CoursePointsDetailDialog.vue?vue&type=script&lang=js&"
export * from "./CoursePointsDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./CoursePointsDetailDialog.vue?vue&type=style&index=0&id=7b98ffbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b98ffbe",
  null
  
)

export default component.exports